import React from 'react'
import { Link } from 'react-router-dom'

import ContentTag from './ContentTag'
import AuthorsLabel from './AuthorsLabel'
import InlineSvg from '../image/InlineSvg'
import ClickableCard from '../layout/ClickableCard'
import BookmarkButton from './BookmarkButton'

type Props = {
  title: string,
  authors: string[],
  type: { name: string, icon: string },
  difficulty: string,
  category: string,
  id: number,
  bookmarked?: boolean
}
const DocumentCard: React.FC<Props> = ({ id, title, authors, type, difficulty, category, bookmarked }) => {
  const renderBookmarkButton = () => {
    if(bookmarked) {
      return <BookmarkButton bookmarked onClick={() => {}} />
    }
    return null
  }

  return (
    <ClickableCard>
      <div className='p-3 h-full'>
        <Link to={`/content/documents/${id}`}>
          <div className='h-8 w-full inline-flex justify-between mb-2 xl:mb-4'>
            <div className='w-full flex flex-row items-center justify-between'>
              <div className='flex items-center text-black text-xs gap-x-2'><InlineSvg src={type.icon} className='stroke-deep-green' />{type.name}</div>
              <div className='block sm:hidden'>{renderBookmarkButton()}</div>
            </div>
            <div className='hidden lg:inline-block'><ContentTag label={difficulty} bgColor='deep-green' /></div>
          </div>
          <div className='w-full inline-block'>
            <div className='h-16 xl:h-12 flex items-center justify-between'>
              <p className='line-clamp-3 xl:line-clamp-2 text-black text-xs sm:text-sm font-semibold'>{title}</p>
              <div className='hidden sm:block'>{renderBookmarkButton()}</div>
            </div>
            <div className='text-gray-600 text-xs mt-2 lg:mt-3 font-light'>
              <div className='h-10'>
                <AuthorsLabel authors={authors} />
              </div>
              <div className='text-2xs lg:text-xs flex mt-2 lg:mt-3 lg:gap-x-3 flex justify-between'>
                <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
              </div>
            </div>
          </div>
        </Link>
      </div>
    </ClickableCard>
  )
}

export default DocumentCard
